import { render } from "./wage-evaluate-basework.vue?vue&type=template&id=25705df8"
import script from "./wage-evaluate-basework.vue?vue&type=script&lang=js"
export * from "./wage-evaluate-basework.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/wagesetting/wage-evaluate-basework.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25705df8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25705df8', __exports__)) {
    api.reload('25705df8', __exports__)
  }
  
  module.hot.accept("./wage-evaluate-basework.vue?vue&type=template&id=25705df8", () => {
    api.rerender('25705df8', render)
  })

}


export default __exports__